import { render, staticRenderFns } from "./IndicatorsModal.vue?vue&type=template&id=2e638f4c"
import script from "./indicatorsModal.js?vue&type=script&lang=js&external"
export * from "./indicatorsModal.js?vue&type=script&lang=js&external"
import style0 from "./indicatorsModal.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e638f4c')) {
      api.createRecord('2e638f4c', component.options)
    } else {
      api.reload('2e638f4c', component.options)
    }
    module.hot.accept("./IndicatorsModal.vue?vue&type=template&id=2e638f4c", function () {
      api.rerender('2e638f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/IndicatorsModal.vue"
export default component.exports